import ConversationEffect from "src/Animations/ConversationEffect";
import setCurrentPage from "src/Utils/setCurrentPage";

export const DATA_GEN_AI_DEMO_ISNA_2 = {
  title: "Retrieve contextual insights",
  subtitle: "Gen AI Demo",
  text: "Context-based Gen AI can be triggered by an \n alarm and will assist the NOC user to\nunderstand the performance of a device. The\nAI assistant will also provide suggestions to ask\nthe right questions and aid in user diagnosis.",
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ENG_208"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ENG_206"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ENG/ISNA/ISNA_GEN_AI_Demo_01.jpg",
  rightSideComponent: (
    <ConversationEffect
      images={[
        {
          image: "ENG/ISNA/ISNA_GEN_AI_Demo_02_bubble_part_1.png",
          imageStyle: { position: "absolute", right: "166px", top: "180px" },
        },
        {
          image: "ENG/ISNA/ISNA_GEN_AI_Demo_02_bubble_part_2.png",
          imageStyle: { position: "absolute", right: "166px", top: "180px" },
          effect: "animate-opacity",
        },
        {
          image: "ENG/ISNA/ISNA_GEN_AI_Demo_02_bubble_part_3.png",
          imageStyle: { position: "absolute", right: "232px", top: "270px" },
        },
        {
          image: "ENG/ISNA/ISNA_GEN_AI_Demo_02_bubble_part_4.png",
          imageStyle: {
            position: "absolute",
            right: "189px",
            top: "400px",
            marginTop: "-8px",
          },
        },
      ]}
      pageNumber={"ENG_207"}
      conversationStyle={{
        width: "auto",
        alignItems: "center",
        marginRight: "90px",
      }}
    />
  ),
};
